import { IDENTIFICATION } from 'constants/statusProcess';

import { ERROR_CODES } from 'constants/video/videoselfie';

export const getErrorFromFinishResponse = ({ ok }) => {
    if (ok) return null;

    return {
        errorCode: ERROR_CODES.GENERIC_NETWORK_ERROR,
        status: IDENTIFICATION,
    };
};
